import { Container, Grid, Typography } from "@material-ui/core"
import React, {useEffect} from "react"
import { getAllUsers } from "../../Sevices/api-requests"
import MyBackdrop from "../Modals/backDrop"
import EnhancedTable from "../Table/table"


const Users = ({user}) => {
    const [users, setUsers] = React.useState({})
// const [one,setOne]=mReact.useState([])
// const [two,setOne]=mReact.useState([])
// const [three,setOne]=mReact.useState([])
// const [four,setOne]=mReact.useState([])
// const [five,setOne]=mReact.useState([])
// const [six,setOne]=mReact.useState([])
// const [seven,setseven]=mReact.useState([])  
    useEffect(() => {
        getUsers()
    },[])

    const getUsers = async () => {
      return  await getAllUsers().then(result => {
            setUsers(result.data.data)
        }).catch(err=>{
            console.log(err)
        })
    }
    return Object.keys(users).length === 0 ? <MyBackdrop /> : (<div >
        {user.matricNo === "220998"|| user.matricNo === "213122" ?
            <Container style={{ marginTop: "5%", marginBottom: "5%", maxWidth: "90vw" }}>
                <Typography style={{ marginBottom: "4%", fontSize: '18px', textAlign: "center", justifySelf: "center" }}>Total Registered Users:{[...users[100], ...users[200], ...users[300], ...users[400], ...users[500], ...users[600]].length}</Typography>
                <Grid >
                    <Typography style={{ marginBottom: "2%" }}> Total registered in 100 Level:{users["100"].length}</Typography>
                    <EnhancedTable rows={[...users["100"]]} />
                </Grid>
                <Grid >
                    <Typography style={{ marginBottom: "2%" }}> Total registered in 200 Level:{users["200"].length}</Typography>
                    <EnhancedTable rows={[...users["200"]]} />
                </Grid>
                <Grid >
                    <Typography style={{ marginBottom: "2%" }}> Total registered in 300 Level:  {"   "} {users["300"].length}</Typography>
                    <EnhancedTable rows={[...users["300"]]} />
                </Grid>
                <Grid >
                    <Typography style={{ marginBottom: "2%" }}> Total registered in 400 Level:{users["400"].length}</Typography>
                    <EnhancedTable rows={[...users["400"]]} />
                </Grid>
                <Grid >
                    <Typography style={{ marginBottom: "2%" }}> Total Registered in 500 Level:{users["500"].length}</Typography>
                    <EnhancedTable rows={[...users["500"]]} />
                </Grid>
                <Grid >
                    <Typography style={{ marginBottom: "2%" }} > Total Registered in 600 Level:{users["600"].length}</Typography>
                    <EnhancedTable rows={[...users["600"]]} />
                </Grid>
                {/* <Grid >
                    <Typography style={{ marginBottom: "2%" }}> Total Registered in 700 Level:{users["700"].length}</Typography>
                    <EnhancedTable rows={[...users["700"]]} />
                </Grid> */}
        
            </Container>
:<Typography  style={{textAlign:"center", marginTop:"50vh"}}>You do not have access to view this page</Typography>}
        
    </div>)
}

export default Users